import ContentLoader from 'react-content-loader'

type TitleCategoryProps = {
  isMobile: boolean
}

export const TitleCategory: React.FC<TitleCategoryProps> = ({ isMobile }) => {
  if (isMobile) {
    return (
      <ContentLoader
        backgroundColor="#e0e0e0"
        foregroundColor="#ecebeb"
        height="60"
        id="load-search-title"
        speed={2}
        title="Carregando..."
        width="100%"
      >
        <rect x="0" y="16" rx="8" ry="8" width="40%" height="18" />
      </ContentLoader>
    )
  }

  return (
    <ContentLoader
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      height="60"
      id="load-search-title"
      speed={2}
      title="Carregando..."
      width="100%"
    >
      <rect x="0" y="0" rx="8" ry="8" width="20%" height="24" />
    </ContentLoader>
  )
}
